module.exports = __webpack_public_path__ + "img/iconfinder_disc.e7092cc9.svg";